import './Slider.scss'

import Carousel from 'antd/es/carousel'
import SelectBranchModal from 'components/select-branch-modal/SelectBranchModal'
import useMediaQuery from 'hooks/useMediaQuery'
import React, { useRef, useState } from 'react'

interface Props {
  onClassSelected: (selectedClassId: number) => void
  banner: any
  okulId: number
}

const Slider: React.FC<Props> = ({ onClassSelected, banner, okulId }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const isMobile = useMediaQuery(768)
  var images = [...banner]
  images.sort((a: any, b: any) => a.sira && b.sira && a.sira - b.sira)
  const ref: any = useRef()

  return (
    <>
      <div className="slider">
        <Carousel arrows={false} ref={ref} swipeToSlide draggable autoplay autoplaySpeed={4000}>
          {images.map((img: any) => {
            const src = isMobile ? img.resim_mobil : img.resim
            return (
              <div key={img.id} className="relative-container">
                <div
                  className="blur-bg"
                  style={{ backgroundImage: `url(${src})` }}
                />
                <img
                  onClick={() => {
                    setModalOpen(true)
                  }}
                  src={src}
                  className="banner-image"
                  alt=""
                />
              </div>
            )
          })}
        </Carousel>
      </div>
      <SelectBranchModal onClassSelected={onClassSelected} modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </>
  )
}

export default Slider
